var map = {
	"./ActiveLifestyleCarrefour/receipt.svg": 8546,
	"./ActiveLifestyleCarrefour/register.svg": 79829,
	"./ActiveLifestyleCarrefour/reward.svg": 23595,
	"./ActiveLifestyleCarrefour/select.svg": 15282,
	"./ActiveLifestyleCora/receipt.svg": 86206,
	"./ActiveLifestyleCora/register.svg": 57665,
	"./ActiveLifestyleCora/reward.svg": 78783,
	"./ActiveLifestyleCora/select.svg": 38334,
	"./ActiveLifestyleMega/receipt.svg": 54341,
	"./ActiveLifestyleMega/register.svg": 80644,
	"./ActiveLifestyleMega/reward.svg": 34738,
	"./ActiveLifestyleMega/select.svg": 13067,
	"./AjaxAxion2023/receipt.svg": 33526,
	"./AjaxAxion2023/register.svg": 25641,
	"./AjaxAxion2023/reward.svg": 37687,
	"./AjaxAxion2023/select.svg": 85926,
	"./Auchan2022/receipt.svg": 3310,
	"./Auchan2022/register.svg": 30449,
	"./Auchan2022/reward.svg": 80303,
	"./Auchan2022/select.svg": 66158,
	"./AutumnCleaning2022/receipt.svg": 77243,
	"./AutumnCleaning2022/register.svg": 68542,
	"./AutumnCleaning2022/reward.svg": 80488,
	"./AutumnCleaning2022/select.svg": 73709,
	"./Autumncleaning2023/receipt.svg": 29018,
	"./Autumncleaning2023/register.svg": 88573,
	"./Autumncleaning2023/reward.svg": 7331,
	"./Autumncleaning2023/select.svg": 27034,
	"./Carrefour2022/receipt.svg": 41275,
	"./Carrefour2022/register.svg": 19326,
	"./Carrefour2022/reward.svg": 10696,
	"./Carrefour2022/select.svg": 19181,
	"./CarrefourAniversar2024/receipt.svg": 29472,
	"./CarrefourAniversar2024/register.svg": 61455,
	"./CarrefourAniversar2024/reward.svg": 3497,
	"./CarrefourAniversar2024/select.svg": 47460,
	"./CarrefourAniversar2025/receipt.svg": 70977,
	"./CarrefourAniversar2025/register.svg": 49056,
	"./CarrefourAniversar2025/reward.svg": 24246,
	"./CarrefourAniversar2025/select.svg": 15015,
	"./ColgateAugust2022/receipt.svg": 75646,
	"./ColgateAugust2022/register.svg": 56481,
	"./ColgateAugust2022/reward.svg": 82143,
	"./ColgateAugust2022/select.svg": 79646,
	"./ColgateCarrefour21Ani/receipt.svg": 79863,
	"./ColgateCarrefour21Ani/register.svg": 73674,
	"./ColgateCarrefour21Ani/reward.svg": 50396,
	"./ColgateCarrefour21Ani/select.svg": 97897,
	"./ColgateCharcoal/receipt.svg": 84322,
	"./ColgateCharcoal/register.svg": 46933,
	"./ColgateCharcoal/reward.svg": 60075,
	"./ColgateCharcoal/select.svg": 14418,
	"./ColgateElixirCarrefour2022/receipt.svg": 55579,
	"./ColgateElixirCarrefour2022/register.svg": 34238,
	"./ColgateElixirCarrefour2022/reward.svg": 38984,
	"./ColgateElixirCarrefour2022/select.svg": 15853,
	"./ColgateEquityCarrefourJan2022/factura.svg": 23700,
	"./ColgateEquityCarrefourJan2022/produse.svg": 10256,
	"./ColgateEquityCarrefourJan2022/register.svg": 45548,
	"./ColgateEquityCarrefourJan2022/reward.svg": 49753,
	"./ColgateIT/receipt.svg": 83804,
	"./ColgateIT/register.svg": 85771,
	"./ColgateIT/reward.svg": 9725,
	"./ColgateIT/select.svg": 92944,
	"./ColgateKaufland2025/cashback.svg": 35936,
	"./ColgateKaufland2025/product.svg": 62113,
	"./ColgateKaufland2025/receipt.svg": 98704,
	"./ColgateKaufland2025/register.svg": 98527,
	"./ColgateLDP2026/receipt.svg": 29029,
	"./ColgateLDP2026/register.svg": 32644,
	"./ColgateLDP2026/reward.svg": 20722,
	"./ColgateLDP2026/select.svg": 25931,
	"./ColgateLLDP2025/receipt.svg": 15242,
	"./ColgateLLDP2025/register.svg": 26957,
	"./ColgateLLDP2025/reward.svg": 17139,
	"./ColgateLLDP2025/select.svg": 86090,
	"./ColgateLidl2025/receipt.svg": 78867,
	"./ColgateLidl2025/register.svg": 22054,
	"./ColgateLidl2025/reward.svg": 33184,
	"./ColgateLidl2025/select.svg": 57461,
	"./ColgateLidl2026/receipt.svg": 436,
	"./ColgateLidl2026/register.svg": 17875,
	"./ColgateLidl2026/reward.svg": 32661,
	"./ColgateLidl2026/select.svg": 9592,
	"./ColgateMax2023/receipt.svg": 51874,
	"./ColgateMax2023/register.svg": 20949,
	"./ColgateMax2023/reward.svg": 57835,
	"./ColgateMax2023/select.svg": 49522,
	"./ColgateMaxAuchan2023/receipt.svg": 75608,
	"./ColgateMaxAuchan2023/register.svg": 85431,
	"./ColgateMaxAuchan2023/reward.svg": 66369,
	"./ColgateMaxAuchan2023/select.svg": 92780,
	"./ColgateOHM2024/receipt.svg": 38525,
	"./ColgateOHM2024/register.svg": 7756,
	"./ColgateOHM2024/reward.svg": 8106,
	"./ColgateOHM2024/select.svg": 69267,
	"./ColgateOHMLDP2024/receipt.svg": 98061,
	"./ColgateOHMLDP2024/register.svg": 43036,
	"./ColgateOHMLDP2024/reward.svg": 2138,
	"./ColgateOHMLDP2024/select.svg": 26755,
	"./ColgatePalmolive2023/receipt.svg": 86245,
	"./ColgatePalmolive2023/register.svg": 23972,
	"./ColgatePalmolive2023/reward.svg": 35570,
	"./ColgatePalmolive2023/select.svg": 89003,
	"./ColgatePalmoliveLidl2026/receipt.svg": 96090,
	"./ColgatePalmoliveLidl2026/register.svg": 18236,
	"./ColgatePalmoliveLidl2026/reward.svg": 18618,
	"./ColgatePalmoliveLidl2026/select.svg": 16835,
	"./ColgateSeptember2023/receipt.svg": 31941,
	"./ColgateSeptember2023/register.svg": 69796,
	"./ColgateSeptember2023/reward.svg": 71986,
	"./ColgateSeptember2023/select.svg": 50315,
	"./ColgateSummer2023/receipt.svg": 50675,
	"./ColgateSummer2023/register.svg": 10310,
	"./ColgateSummer2023/reward.svg": 10400,
	"./ColgateSummer2023/select.svg": 7829,
	"./ColgateSummerKaufland2023/receipt.svg": 57573,
	"./ColgateSummerKaufland2023/register.svg": 49028,
	"./ColgateSummerKaufland2023/reward.svg": 89810,
	"./ColgateSummerKaufland2023/select.svg": 43243,
	"./ColgateTotal2023/receipt.svg": 22698,
	"./ColgateTotal2023/register.svg": 6701,
	"./ColgateTotal2023/reward.svg": 35219,
	"./ColgateTotal2023/select.svg": 69674,
	"./ColgateTotal2024/receipt.svg": 19633,
	"./ColgateTotal2024/register.svg": 64336,
	"./ColgateTotal2024/reward.svg": 30438,
	"./ColgateTotal2024/select.svg": 55031,
	"./ColgateTotal2025/receipt.svg": 74736,
	"./ColgateTotal2025/register.svg": 65663,
	"./ColgateTotal2025/reward.svg": 75417,
	"./ColgateTotal2025/select.svg": 55988,
	"./ColgateTotal2026/receipt.svg": 19439,
	"./ColgateTotal2026/register.svg": 24114,
	"./ColgateTotal2026/reward.svg": 33172,
	"./ColgateTotal2026/select.svg": 93233,
	"./ColgateTotalActivePrevention2025/receipt.svg": 23082,
	"./ColgateTotalActivePrevention2025/register.svg": 66573,
	"./ColgateTotalActivePrevention2025/reward.svg": 45875,
	"./ColgateTotalActivePrevention2025/select.svg": 59050,
	"./ColgateTotalAutumn2026/receipt.svg": 38077,
	"./ColgateTotalAutumn2026/register.svg": 62412,
	"./ColgateTotalAutumn2026/reward.svg": 94890,
	"./ColgateTotalAutumn2026/select.svg": 55059,
	"./ColgateTotalCarrefour2022/receipt.svg": 29814,
	"./ColgateTotalCarrefour2022/register.svg": 46217,
	"./ColgateTotalCarrefour2022/reward.svg": 10231,
	"./ColgateTotalCarrefour2022/select.svg": 76230,
	"./ColgateTotalDM2022/receipt.svg": 74906,
	"./ColgateTotalDM2022/register.svg": 69341,
	"./ColgateTotalDM2022/reward.svg": 48835,
	"./ColgateTotalDM2022/select.svg": 38234,
	"./ColgateTotalMegaImage2022/receipt.svg": 69386,
	"./ColgateTotalMegaImage2022/register.svg": 13005,
	"./ColgateTotalMegaImage2022/reward.svg": 42451,
	"./ColgateTotalMegaImage2022/select.svg": 11402,
	"./ColgateUltra2023/receipt.svg": 91778,
	"./ColgateUltra2023/register.svg": 62197,
	"./ColgateUltra2023/reward.svg": 36139,
	"./ColgateUltra2023/select.svg": 42642,
	"./ColgateWhiteMoneyBack2024/receipt.svg": 78703,
	"./ColgateWhiteMoneyBack2024/register.svg": 88434,
	"./ColgateWhiteMoneyBack2024/reward.svg": 59636,
	"./ColgateWhiteMoneyBack2024/select.svg": 58129,
	"./ColgateWhiteMoneyBack2025/receipt.svg": 66366,
	"./ColgateWhiteMoneyBack2025/register.svg": 1441,
	"./ColgateWhiteMoneyBack2025/reward.svg": 66591,
	"./ColgateWhiteMoneyBack2025/select.svg": 31902,
	"./ColgateWhitening2023/receipt.svg": 70861,
	"./ColgateWhitening2023/register.svg": 64188,
	"./ColgateWhitening2023/reward.svg": 53594,
	"./ColgateWhitening2023/select.svg": 51811,
	"./ColgateWhitening2024/receipt.svg": 89950,
	"./ColgateWhitening2024/register.svg": 57409,
	"./ColgateWhitening2024/reward.svg": 65919,
	"./ColgateWhitening2024/select.svg": 14878,
	"./ColgateWhiteningAuchan2022/receipt.svg": 85938,
	"./ColgateWhiteningAuchan2022/register.svg": 95461,
	"./ColgateWhiteningAuchan2022/reward.svg": 27739,
	"./ColgateWhiteningAuchan2022/select.svg": 36322,
	"./ColgateWhiteningCarrefour2022/receipt.svg": 28375,
	"./ColgateWhiteningCarrefour2022/register.svg": 35210,
	"./ColgateWhiteningCarrefour2022/reward.svg": 82908,
	"./ColgateWhiteningCarrefour2022/select.svg": 82505,
	"./ColgateWhiteningSelgros2024/receipt.svg": 96561,
	"./ColgateWhiteningSelgros2024/register.svg": 84560,
	"./ColgateWhiteningSelgros2024/reward.svg": 53382,
	"./ColgateWhiteningSelgros2024/select.svg": 23703,
	"./ColgateWomenDay2024/receipt.svg": 9791,
	"./ColgateWomenDay2024/register.svg": 74850,
	"./ColgateWomenDay2024/reward.svg": 28484,
	"./ColgateWomenDay2024/select.svg": 63169,
	"./ColgateWomenDay2025/receipt.svg": 32270,
	"./ColgateWomenDay2025/register.svg": 2001,
	"./ColgateWomenDay2025/reward.svg": 39535,
	"./ColgateWomenDay2025/select.svg": 25390,
	"./ColgateWomenDay2026/receipt.svg": 91745,
	"./ColgateWomenDay2026/register.svg": 608,
	"./ColgateWomenDay2026/reward.svg": 44374,
	"./ColgateWomenDay2026/select.svg": 61223,
	"./Elmex-MB2023/receipt.svg": 79288,
	"./Elmex-MB2023/register.svg": 40407,
	"./Elmex-MB2023/reward.svg": 1121,
	"./Elmex-MB2023/select.svg": 95724,
	"./Elmex2023/receipt.svg": 41556,
	"./Elmex2023/register.svg": 18739,
	"./Elmex2023/reward.svg": 30325,
	"./Elmex2023/select.svg": 7640,
	"./ElmexAuchanFeb2022/receipt.svg": 4032,
	"./ElmexAuchanFeb2022/register.svg": 6639,
	"./ElmexAuchanFeb2022/reward.svg": 30409,
	"./ElmexAuchanFeb2022/select.svg": 5764,
	"./ElmexAugust2022/receipt.svg": 9702,
	"./ElmexAugust2022/register.svg": 62969,
	"./ElmexAugust2022/reward.svg": 40231,
	"./ElmexAugust2022/select.svg": 83318,
	"./ElmexCarrefourFeb2022/receipt.svg": 49437,
	"./ElmexCarrefourFeb2022/register.svg": 74444,
	"./ElmexCarrefourFeb2022/reward.svg": 71114,
	"./ElmexCarrefourFeb2022/select.svg": 31283,
	"./ElmexCarrefourJuly2022/receipt.svg": 63642,
	"./ElmexCarrefourJuly2022/register.svg": 11197,
	"./ElmexCarrefourJuly2022/reward.svg": 21155,
	"./ElmexCarrefourJuly2022/select.svg": 40858,
	"./ElmexIT2023/receipt.svg": 79667,
	"./ElmexIT2023/register.svg": 10502,
	"./ElmexIT2023/reward.svg": 93760,
	"./ElmexIT2023/select.svg": 18037,
	"./ElmexMegaFeb2022/receipt.svg": 41808,
	"./ElmexMegaFeb2022/register.svg": 34175,
	"./ElmexMegaFeb2022/reward.svg": 69369,
	"./ElmexMegaFeb2022/select.svg": 27700,
	"./ElmexMoneyBack2024/receipt.svg": 8498,
	"./ElmexMoneyBack2024/register.svg": 3397,
	"./ElmexMoneyBack2024/reward.svg": 10427,
	"./ElmexMoneyBack2024/select.svg": 2178,
	"./ElmexMoneyBack2025/receipt.svg": 17971,
	"./ElmexMoneyBack2025/register.svg": 646,
	"./ElmexMoneyBack2025/reward.svg": 31968,
	"./ElmexMoneyBack2025/select.svg": 47797,
	"./IngrijirePersonalaKaufland2025/receipt.svg": 30925,
	"./IngrijirePersonalaKaufland2025/register.svg": 23516,
	"./IngrijirePersonalaKaufland2025/reward.svg": 18810,
	"./IngrijirePersonalaKaufland2025/select.svg": 17027,
	"./Ladyspeedstick2023/receipt.svg": 31834,
	"./Ladyspeedstick2023/register.svg": 85661,
	"./Ladyspeedstick2023/reward.svg": 65187,
	"./Ladyspeedstick2023/select.svg": 68538,
	"./LidlBeauty2025/receipt.svg": 27466,
	"./LidlBeauty2025/register.svg": 70829,
	"./LidlBeauty2025/reward.svg": 23699,
	"./LidlBeauty2025/select.svg": 92650,
	"./MegaImage2022/receipt.svg": 96971,
	"./MegaImage2022/register.svg": 61678,
	"./MegaImage2022/reward.svg": 67704,
	"./MegaImage2022/select.svg": 861,
	"./Moneyback2022/receipt.svg": 23403,
	"./Moneyback2022/register.svg": 70350,
	"./Moneyback2022/reward.svg": 66072,
	"./Moneyback2022/select.svg": 99229,
	"./Palmolive2023/receipt.svg": 91942,
	"./Palmolive2023/register.svg": 84825,
	"./Palmolive2023/reward.svg": 88263,
	"./Palmolive2023/select.svg": 17814,
	"./PalmoliveCarrefourJune2022/receipt.svg": 27450,
	"./PalmoliveCarrefourJune2022/register.svg": 78973,
	"./PalmoliveCarrefourJune2022/reward.svg": 99651,
	"./PalmoliveCarrefourJune2022/select.svg": 94266,
	"./PalmoliveChristmas2024/receipt.svg": 23881,
	"./PalmoliveChristmas2024/register.svg": 26840,
	"./PalmoliveChristmas2024/reward.svg": 98654,
	"./PalmoliveChristmas2024/select.svg": 47071,
	"./PalmoliveExperentials2023/receipt.svg": 47900,
	"./PalmoliveExperentials2023/register.svg": 84139,
	"./PalmoliveExperentials2023/reward.svg": 77373,
	"./PalmoliveExperentials2023/select.svg": 25296,
	"./PalmoliveLifestyle2024/receipt.svg": 17888,
	"./PalmoliveLifestyle2024/register.svg": 623,
	"./PalmoliveLifestyle2024/reward.svg": 90089,
	"./PalmoliveLifestyle2024/select.svg": 17700,
	"./PalmoliveSmoothies2022/receipt.svg": 30120,
	"./PalmoliveSmoothies2022/register.svg": 87719,
	"./PalmoliveSmoothies2022/reward.svg": 20305,
	"./PalmoliveSmoothies2022/select.svg": 37020,
	"./PalmoliveSummer2023/receipt.svg": 16277,
	"./PalmoliveSummer2023/register.svg": 75540,
	"./PalmoliveSummer2023/reward.svg": 15426,
	"./PalmoliveSummer2023/select.svg": 64219,
	"./Protex2023/receipt.svg": 27613,
	"./Protex2023/register.svg": 7116,
	"./Protex2023/reward.svg": 80330,
	"./Protex2023/select.svg": 40499,
	"./Protex2024/receipt.svg": 35118,
	"./Protex2024/register.svg": 59121,
	"./Protex2024/reward.svg": 77679,
	"./Protex2024/select.svg": 63534,
	"./ProtexCarrefour/factura.svg": 13877,
	"./ProtexCarrefour/register.svg": 46696,
	"./ProtexCarrefourJan2022/factura.svg": 91084,
	"./ProtexCarrefourJan2022/produse.svg": 84696,
	"./ProtexCarrefourJan2022/register.svg": 43607,
	"./ProtexCarrefourJan2022/reward.svg": 63329,
	"./ProtexCharcoalCarrefour2022/receipt.svg": 53159,
	"./ProtexCharcoalCarrefour2022/register.svg": 4851,
	"./ProtexCharcoalCarrefour2022/reward.svg": 6293,
	"./ProtexCharcoalCarrefour2022/select.svg": 83608,
	"./ProtexCharcoalCora2022/receipt.svg": 68192,
	"./ProtexCharcoalCora2022/register.svg": 83663,
	"./ProtexCharcoalCora2022/reward.svg": 96201,
	"./ProtexCharcoalCora2022/select.svg": 27460,
	"./ProtexCharcoalMega2022/receipt.svg": 89859,
	"./ProtexCharcoalMega2022/register.svg": 37142,
	"./ProtexCharcoalMega2022/reward.svg": 37584,
	"./ProtexCharcoalMega2022/select.svg": 35205,
	"./ProtexHealthProtection2023/receipt.svg": 32686,
	"./ProtexHealthProtection2023/register.svg": 76529,
	"./ProtexHealthProtection2023/reward.svg": 75279,
	"./ProtexHealthProtection2023/select.svg": 61134,
	"./ProtexSummerCarrefour2022/receipt.svg": 9726,
	"./ProtexSummerCarrefour2022/register.svg": 18401,
	"./ProtexSummerCarrefour2022/reward.svg": 76895,
	"./ProtexSummerCarrefour2022/select.svg": 74398,
	"./ProtexSummerRomania/receipt.svg": 22400,
	"./ProtexSummerRomania/register.svg": 70415,
	"./ProtexSummerRomania/reward.svg": 42249,
	"./ProtexSummerRomania/select.svg": 73508,
	"./Protexcashback2025/cashback.svg": 95509,
	"./Protexcashback2025/product.svg": 79986,
	"./Protexcashback2025/receipt.svg": 67603,
	"./Protexcashback2025/register.svg": 58150,
	"./SpringCleaning2025/cashback.svg": 74123,
	"./SpringCleaning2025/product.svg": 62796,
	"./SpringCleaning2025/receipt.svg": 83617,
	"./SpringCleaning2025/register.svg": 90752,
	"./SpringCleaningCarrefour2022/receipt.svg": 17489,
	"./SpringCleaningCarrefour2022/register.svg": 58192,
	"./SpringCleaningCarrefour2022/reward.svg": 34182,
	"./SpringCleaningCarrefour2022/select.svg": 4503,
	"./SpringCleaningCora2022/receipt.svg": 97655,
	"./SpringCleaningCora2022/register.svg": 70794,
	"./SpringCleaningCora2022/reward.svg": 97148,
	"./SpringCleaningCora2022/select.svg": 91849,
	"./SpringCleaningMega2022/receipt.svg": 89672,
	"./SpringCleaningMega2022/register.svg": 49383,
	"./SpringCleaningMega2022/reward.svg": 29265,
	"./SpringCleaningMega2022/select.svg": 29628,
	"./Springcleaning2024/receipt.svg": 83904,
	"./Springcleaning2024/register.svg": 24431,
	"./Springcleaning2024/reward.svg": 68809,
	"./Springcleaning2024/select.svg": 68,
	"./SummerExperience2024/receipt.svg": 73761,
	"./SummerExperience2024/register.svg": 69056,
	"./SummerExperience2024/reward.svg": 45622,
	"./SummerExperience2024/select.svg": 16807,
	"./SummerJoy2025/receipt.svg": 61378,
	"./SummerJoy2025/register.svg": 23797,
	"./SummerJoy2025/reward.svg": 70443,
	"./SummerJoy2025/select.svg": 24786,
	"./SummerJoy2026/receipt.svg": 29509,
	"./SummerJoy2026/register.svg": 69636,
	"./SummerJoy2026/reward.svg": 10098,
	"./SummerJoy2026/select.svg": 72075,
	"./WomenDay2024/receipt.svg": 15038,
	"./WomenDay2024/register.svg": 10593,
	"./WomenDay2024/reward.svg": 99967,
	"./WomenDay2024/select.svg": 48926,
	"./WomenDay2025/cashback.svg": 14657,
	"./WomenDay2025/product.svg": 55254,
	"./WomenDay2025/receipt.svg": 27375,
	"./WomenDay2025/register.svg": 81234,
	"./WomenDay2026/cashback.svg": 51168,
	"./WomenDay2026/product.svg": 95105,
	"./WomenDay2026/receipt.svg": 31696,
	"./WomenDay2026/register.svg": 13759,
	"./WomenDay2026/reward.svg": 97689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58014;